import React from "react";
import MenuIcon from "@material-ui/icons/Menu";
import NotificationsIcon from "@material-ui/icons/Notifications";
import HomeIcon from "@material-ui/icons/Home";
import ScienceIcon from "@material-ui/icons/OpacityOutlined";
import AssignmentIcon from "@material-ui/icons/Assignment";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import BuildIcon from "@material-ui/icons/Build";
import GroupIcon from "@material-ui/icons/Group";
import TimelineIcon from "@material-ui/icons/Timeline";
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import GetAppIcon from "@material-ui/icons/GetApp";
import PublishIcon from "@material-ui/icons/Publish";
import EditIcon from "@material-ui/icons/Edit";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import GavelIcon from "@material-ui/icons/Gavel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import ReplyIcon from "@material-ui/icons/Reply";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import ScheduleIcon from "@material-ui/icons/Schedule";
import LockIcon from "@material-ui/icons/Lock";
import CommentIcon from "@material-ui/icons/Comment";
import AddCommentIcon from "@material-ui/icons/AddComment";
import SpeakerNotesOffIcon from "@material-ui/icons/SpeakerNotesOff";
import NoteIcon from "@material-ui/icons/Note";
import NotesIcon from "@material-ui/icons/Notes";
import DescriptionIcon from "@material-ui/icons/Description";
import TaskIcon from "@material-ui/icons/AssignmentTurnedIn";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import WarningIcon from "@material-ui/icons/Warning";
import InfoIcon from "@material-ui/icons/Info";
import SaveIcon from "@material-ui/icons/Save";
import SendIcon from "@material-ui/icons/Send";
import PersonIcon from "@material-ui/icons/Person";
import HowToRegIcon from "@material-ui/icons/HowToReg";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import LinkIcon from "@material-ui/icons/Link";
import FlagIcon from "@material-ui/icons/Flag";
import HistoryIcon from "@material-ui/icons/History";
import LayersIcon from "@material-ui/icons/Layers";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import EventIcon from "@material-ui/icons/Event";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import ListAltIcon from "@material-ui/icons/ListAlt";
import ShowChartIcon from "@material-ui/icons/ShowChart";
import InboxIcon from "@material-ui/icons/Inbox";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

type IconComp = React.ComponentType<{ style?: React.CSSProperties; fontSize?: any }>;

/**
 * Maps mockup token names (Tabler-derived) to Material UI Icons v4.
 * Anywhere the mockup wrote `ti-foo`, code passes token 'foo' to <MI /> and this table
 * resolves it. Missing tokens fall back to InfoIcon so the UI never crashes.
 */
export const ICONS: Record<string, IconComp> = {
  menu: MenuIcon,
  bell: NotificationsIcon,
  home: HomeIcon,
  flask: ScienceIcon,
  clipboard: AssignmentIcon,
  folders: FolderOpenIcon,
  tool: BuildIcon,
  users: GroupIcon,
  route: TimelineIcon,
  search: SearchIcon,
  filter: FilterListIcon,
  download: GetAppIcon,
  upload: PublishIcon,
  pencil: EditIcon,
  checklist: PlaylistAddCheckIcon,
  verify: AssignmentTurnedInIcon,
  stamp: GavelIcon,
  circleCheck: CheckCircleIcon,
  circleDashed: RadioButtonUncheckedIcon,
  back: ReplyIcon,
  arrowRight: ArrowForwardIcon,
  arrowLeft: ArrowBackIcon,
  playArrow: PlayArrowIcon,
  eye: VisibilityIcon,
  eyeOff: VisibilityOffIcon,
  clock: ScheduleIcon,
  lock: LockIcon,
  message: CommentIcon,
  messagePlus: AddCommentIcon,
  messageOff: SpeakerNotesOffIcon,
  note: NoteIcon,
  notes: NotesIcon,
  fileText: DescriptionIcon,
  fileCheck: TaskIcon,
  fileDownload: SaveAltIcon,
  fileDescription: InsertDriveFileIcon,
  alertCircle: ErrorOutlineIcon,
  alertTriangle: WarningIcon,
  infoCircle: InfoIcon,
  deviceFloppy: SaveIcon,
  send: SendIcon,
  user: PersonIcon,
  userCheck: HowToRegIcon,
  userCircle: AccountCircleIcon,
  chevronDown: ExpandMoreIcon,
  chevronRight: ChevronRightIcon,
  chevronLeft: ChevronLeftIcon,
  dots: MoreHorizIcon,
  x: CloseIcon,
  check: CheckIcon,
  link: LinkIcon,
  flag: FlagIcon,
  versions: HistoryIcon,
  stack: LayersIcon,
  calendar: CalendarTodayIcon,
  calendarEvent: EventIcon,
  calendarPlus: EventAvailableIcon,
  listAlt: ListAltIcon,
  chart: ShowChartIcon,
  inbox: InboxIcon,
  checkbox: CheckBoxIcon,
  description: DescriptionIcon,
};

interface MIProps {
  name: string;
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}

export const MI: React.FC<MIProps> = ({ name, size, color, style }) => {
  const Comp = ICONS[name] || InfoIcon;
  const s: React.CSSProperties = { fontSize: size, color, ...style };
  return <Comp style={s} />;
};
